import { useEffect } from 'react';
import { useApiError } from '../context/ApiErrorContext';

/**
 * Hook to handle API errors captured by the global interceptor.
 * If the provided handler returns `true`, the error is considered handled
 * and will not trigger the generic ErrorAlert.
 */
export const useApiErrorHandler = (handler?: (message: string) => boolean | void) => {
  const { error, clearError } = useApiError();

  useEffect(() => {
    if (!error) return;
    const handled = handler ? handler(error) : false;
    if (handled) {
      clearError();
    }
  }, [error, handler, clearError]);
};
